<template>
  <v-hover v-slot="{ hover }">
    <v-text-field v-model="boolText"
                  class="q-input"
                  :class="[BorderClass, CompactClass, BlurrClass, boolColor + '--inputtext', 'removeunderline']"
                  :background-color="BackgroundColor"
                  :label="labelText"
                  readonly
                  hide-details="auto"
                  :single-line="singleline"
                  :hoverbool="setHoverBool(hover)"
                  :color="boolColor"
                  flat>
      <!-- :rules="[required]" -->

      <!-- PREPEND SLOTS -->
      <template v-slot:prepend>
        <slot name="prepend-outer" />
      </template>

      <template v-slot:prepend-inner>
        <slot name="prepend" />
      </template>
      <!------------------->

      <!-- APPEND SLOTS -->
      <template v-slot:append>
        <v-checkbox v-if="!loading"
                    :input-value="newValue"
                    :disabled="disabled"
                    :readonly="IsDisabled"
                    :color="boolColor"
                    dense
                    :indeterminate="unTamperedIndeterminate"
                    :ripple="!IsDisabled"
                    :rules="rules"
                    hide-details
                    @change="e => changeBool(e)"
                    class="q-checkbox pa-0 ma-0">
        </v-checkbox>
        <v-progress-circular v-else
                             indeterminate
                             size="20"
                             width="2"
                             color="primary">
        </v-progress-circular>
        <ExternalChangeWarning v-if="externallychanged"
                               @Sync="(newValue = value, externallychanged = false)" />
      </template>

      <template v-slot:append-outer>
        <slot name="append-outer" />
      </template>
      <!------------------->

    </v-text-field>
  </v-hover>
</template>


<script>
import InputMixin from "@/helpers/Mixins/InputMixin";
import ExternalChangeWarning from "@/components/Inputs/Parts/ExternalChangeWarning.vue";

export default {
  name: "QCheckboxInput",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    value: Boolean,
    singleline: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    emitOnlyOnBlur: Boolean,
    rules: Array,

    boolcolors: Object,
    booltexts: Object,
    indeterminate: Boolean,
  },
  components: {
    ExternalChangeWarning,
  },
  mixins: [InputMixin],

  data() {
    return {
      edit: false,
      newValue: this.value,
      changedCount: 0,
    };
  },

  methods: {
    changeBool(val) {
      this.setEdit();
      this.newValue = val;
      this.changedCount++;
      this.blurInput();
    },
  },

  computed: {
    boolText() {
      return this.unTamperedIndeterminate ? this.indeterminateText : this.newValue ? this.trueText : this.falseText;
    },
    trueText() {
      return this.booltexts && this.booltexts.true
        ? this.booltexts.true
        : this.$t("servicesystem.common_objects.commonterms.yes");
    },
    indeterminateText() {
      return this.booltexts && this.booltexts.indeterminate
        ? this.booltexts.indeterminate
        : this.$t("servicesystem.common_objects.commonterms.partially");
    },
    falseText() {
      return this.booltexts && this.booltexts.false
        ? this.booltexts.false
        : this.$t("servicesystem.common_objects.commonterms.no");
    },

    boolColor() {
      return this.unTamperedIndeterminate ? this.indeterminateColor : this.newValue ? this.trueColor : this.falseColor;
    },
    trueColor() {
      return this.boolcolors && this.boolcolors.true ? this.boolcolors.true : "primary";
    },
    indeterminateColor() {
      return this.boolcolors && this.boolcolors.indeterminate ? this.boolcolors.indeterminate : this.trueColor;
    },
    falseColor() {
      return this.boolcolors && this.boolcolors.false ? this.boolcolors.false : "tertiary";
    },

    unTamperedIndeterminate() {
      return this.indeterminate && !this.changedCount;
    },
  },

  watch: {},
};
</script>

